import { useEffect, useState } from "react";

const TickCirckeIcon = ({ className, fill = "#2E2E2E" }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={_class}
    >
      <g clip-path="url(#clip0_177531_26182)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.2806 9.21937C16.4215 9.36005 16.5006 9.55094 16.5006 9.75C16.5006 9.94906 16.4215 10.1399 16.2806 10.2806L11.0306 15.5306C10.8899 15.6715 10.6991 15.7506 10.5 15.7506C10.3009 15.7506 10.1101 15.6715 9.96937 15.5306L7.71938 13.2806C7.42632 12.9876 7.42632 12.5124 7.71938 12.2194C8.01243 11.9263 8.48757 11.9263 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.3601 9.07854 15.5509 8.99941 15.75 8.99941C15.9491 8.99941 16.1399 9.07854 16.2806 9.21937ZM21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3824 2.25568 21.7443 6.61758 21.75 12ZM20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5542 20.2448 20.2448 16.5542 20.25 12Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_177531_26182">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TickCirckeIcon;
